module.exports = __webpack_public_path__ + "img/cover-minigame-bg.0908985f.png";